import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppRoutes } from '../../../../../../constants/appRoutes';
import { InvestorStatus } from '../../../../../../constants/investorStatus';
import { buildLocalizeRoute } from '../../../../../../helpers/languageHelper';
import { getUser } from '../../../../../../services/authService';

export const WinddownBanner = () => {
	const { t } = useTranslation();
	const isWinddown = getUser()?.status === InvestorStatus.WindDown;

	if (!isWinddown) {
		return null;
	}

	return (
		<Box className="w-full !bg-amber-50 border-b border-amber-200 !py-2 !px-4 text-center">
			<span className="!text-sm !text-amber-900">
				{t('winddownBannerText')}{' '}
				<a
					className="underline hover:no-underline font-semibold"
					href={buildLocalizeRoute(`${AppRoutes.Investor}/${AppRoutes.Profile}`)}>
					{t('myProfile')}
				</a>
			</span>
		</Box>
	);
};
